import { useLocation } from 'react-router-dom';

import PageMeta from './PageMeta';
import { RedesignFooter, RedesignHeader, RedesignPage, SiteLink } from './RedesignShell';

const pageTitles = {
  '/services/mobile/ecommerce': 'Приложения для интернет-магазинов',
  '/services/mobile/corporate': 'Корпоративные приложения',
  '/services/mobile/delivery': 'Приложения для ресторанов, доставки и сервисов',
  '/services/mobile/redesign-support': 'Редизайн и доработка существующих приложений',
  '/services': 'Услуги',
  '/services/vseuslugi': 'Все услуги',
  '/services/yandex-maps': 'Продвижение в Яндекс.Картах',
  '/calculator': 'Калькулятор разработки',
  '/about': 'О компании',
  '/contacts': 'Контакты',
  '/vacancies': 'Вакансии',
  '/requisites': 'Реквизиты',
  '/privacy': 'Политика конфиденциальности',
  '/offer': 'Оферта',
  '/cookies': 'Cookies',
  '/blog/digital-trends-2026': 'Топ-5 трендов digital-продвижения в 2026 году',
  '/blog/mobile-roi': 'Как рассчитать ROI от разработки мобильного приложения для бизнеса',
  '/blog/seo-top3': 'Кейс: как мы вывели интернет-магазин в ТОП-3 за 6 месяцев',
};

const sourceTodos = {
  '/services/vseuslugi': 'TODO(brand-redesign): add source text for services-vseuslugi',
  '/services/yandex-maps': 'TODO(brand-redesign): add source text for yandex-maps-service',
  '/vacancies': 'TODO(brand-redesign): add source text for vacancies-page',
  '/requisites': 'TODO(brand-redesign): add source text for requisites-page',
  '/blog/digital-trends-2026': 'TODO(brand-redesign): add source text for article-digital-trends-2026',
  '/blog/mobile-roi': 'TODO(brand-redesign): add source text for article-mobile-app-roi',
  '/blog/seo-top3': 'TODO(brand-redesign): add source text for article-ecommerce-top-3',
};

const normalizePath = (path) => {
  if (!path || path === '/') return '/';
  return path.replace(/\/$/, '');
};

function getTitle(pathname) {
  const normalized = normalizePath(pathname);
  if (pageTitles[normalized]) return pageTitles[normalized];
  if (normalized.startsWith('/services/')) return 'Страница услуги';
  if (normalized.startsWith('/portfolio/')) return 'Страница кейса';
  if (normalized.startsWith('/blog/')) return 'Страница статьи';
  return 'Раздел в работе';
}

function PlaceholderPage() {
  const location = useLocation();
  const normalizedPath = normalizePath(location.pathname);
  const pageTitle = getTitle(normalizedPath);
  const sourceTodo = sourceTodos[normalizedPath] || 'TODO(brand-redesign): add source text for placeholder-page';

  return (
    <RedesignPage>
      <PageMeta
        title={`${pageTitle} — Fatality Studio`}
        description={`${pageTitle}: страница находится в работе. ${sourceTodo}`}
      />
      <RedesignHeader />
      <main className="placeholder-page">
        <section className="ink placeholder-hero">
          <div
            className="glow"
            style={{ right: '-320px', top: '-320px', width: '780px', height: '780px', opacity: 0.1 }}
          />
          <div className="container" style={{ position: 'relative' }}>
            <div className="eyebrow cyan">— {sourceTodo}</div>
            <h1>{pageTitle}</h1>
            <p>
              Эта страница нужна новой структуре сайта, но полноценный контент и дизайн ещё не перенесены. Заглушка
              оставлена намеренно, чтобы ссылка не была битой и задача не потерялась.
            </p>
            <div className="placeholder-path">{location.pathname}</div>
            <div className="placeholder-actions">
              <SiteLink href="/" className="btn btn-primary">
                на главную →
              </SiteLink>
              <SiteLink href="/#lead" className="btn btn-ghost-dark">
                обсудить проект
              </SiteLink>
            </div>
          </div>
        </section>
      </main>
      <RedesignFooter />
    </RedesignPage>
  );
}

export default PlaceholderPage;
